/**
 * Configuration centralisée pour l'API
 * Cette configuration permet de modifier facilement l'URL de base de l'API
 * en changeant uniquement cette valeur ou la variable d'environnement
 */

// URL de base de l'API
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://gestion-carte-ci.com/api';
//export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8111/api';

// URL de base pour les fichiers statiques (photos, etc.)
export const STATIC_FILES_BASE_URL = process.env.REACT_APP_STATIC_FILES_URL || 'https://gestion-carte-ci.com/api';
//export const STATIC_FILES_BASE_URL = process.env.REACT_APP_STATIC_FILES_URL || 'http://localhost:8111/api';

/**
 * Construit l'URL complète pour un fichier statique
 * @param {string} filename - Nom du fichier
 * @returns {string} URL complète du fichier
 */
export const getStaticFileUrl = (filename) => {
  if (!filename) return null;
  return `${STATIC_FILES_BASE_URL}/files/photos/${filename}`;
};

/**
 * Construit l'URL complète pour un endpoint API
 * @param {string} endpoint - Endpoint de l'API (ex: '/agents', '/groupes')
 * @returns {string} URL complète de l'endpoint
 */
export const getApiUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`;
};
